export default function headerInfo() {
  return {
    title: '外林のポートフォリオサイト',
    description:
      '閲覧ありがとうございます。外林のポートフォリオサイトです。よろしくお願いいたします。',
  };
}
